export default {
    firstToCreate: 'Sii il primo a creare un thread in questo forum',
    firstToPostInCategory: 'Sii il primo a pubblicare in questa categoria',
    firstToRespondToTopic: 'Sii il primo a rispondere a questo argomento!',
    createNewThread: 'Crea un nuovo thread',
    thread: 'thread',
    viewThread: 'Visualizza thread',
    replies: 'Risposte',
    noReplies: 'Nessuna risposta',
    reply: 'rispondi',
    _reply: 'Rispondi',
    ReplyTo: 'Rispondi a',
    replyToThisQuestion: 'Rispondi a questa domanda',
    onceRepliedModeratorMayRespond: 'Una volta che hai risposto, il moderatore del forum potrebbe rispondere alla tua risposta',
    onceRepliedCanViewResponses: 'Una volta che hai risposto, puoi visualizzare le risposte degli altri partecipanti',
    loadingResponses: 'Caricamento delle risposte',
    hideXReplies: 'Nascondi {count} risposte',
    showXReplies: 'Mostra {count} risposte',
    hideMostRecentReplies: 'Nascondi le risposte più recenti',
    showMostRecentReplies: 'Mostra le risposte più recenti',
    post: 'Pubblica',
    message: 'Messaggio',
    typeMessage: 'Scrivi un messaggio',
    addPost: 'Aggiungi post',
    addMessage: 'Aggiungi messaggio',
    editPost: 'Modifica post',
    editPostWithMedia: 'Modifica post con media',
    createPostWithMedia: 'Crea post con media',
    deleteMessage: 'Elimina messaggio',
    deleteMessageConfirm: 'Sei sicuro di voler eliminare questo messaggio?',
    pinPost: 'Fissa post',
    media: 'Media',
    uploadMedia: 'Carica media',
    categories: 'categorie',
    goBack: 'Torna indietro',
    goBackPrevious: 'Torna alla pagina precedente',
    goBackToCategory: 'Torna alla categoria {name}',
    loadingLatestThreads: 'Caricamento degli ultimi thread',
    loadingDiscussionForum: 'Caricamento del forum di discussione',
    dontShowAgainForTask: `Non mostrare di nuovo per questo compito`,
    title: 'Titolo',
    beTheFirst: 'Sii il primo a rispondere a questo thread'
};
